import { COLORS } from 'helpers/globals'

export default {
  label: {
    color: 'black',
    marginRight: '1.5rem',
    fontSize: '1.4rem'
  },
  helpIcon: {
    marginLeft: '.5rem'
  },
  input: {
    width: '15% !important',
    marginRight: '.5rem',
    transition: 'border 200ms linear, box-shadow 200ms linear',
    '&.invalid': {
      border: `1px solid ${COLORS.danger}`,
      boxShadow: `0 0 5px 0 ${COLORS.danger}`
    },
    '&.default': {
      color: COLORS.secondary
    }
  },
  errorText: {
    fontSize: '1.2rem',
    color: COLORS.danger
  }
}



// WEBPACK FOOTER //
// ./src/components/NetworkClosetDetails/DropLengthInput/style.js